// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__MoQVK","bigColWidth":"Table_bigColWidth__2Yzh7","biggerColWidth":"Table_biggerColWidth__4Svhz","row":"Table_row__3wR40","col":"Table_col__sz2Mp"};